<template>
  <div>
    <iframe
      :src="audienceAppUrl"
      class="embed-audience-app"
    />
  </div>
</template>

<script>
import config from '@/config'

export default {
  data() {
    return {
      audienceAppUrl: `${config.audienceHttpsEndpoint}?zoomApp=true`,
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessageFromAudience, false)
  },
  destroy() {
    window.removeEventListener('message', this.handleMessageFromAudience)
  },
  methods: {
    handleMessageFromAudience(event) {
      if (event.data === 'logoutZoomApp') {
        this.$router.push({
          name: 'ZoomApp',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.embed-audience-app {
  width: 100%;
  height: calc(100vh - 40px);
  border: none;
}
</style>
